import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const emailRecipientsService = createApi({
  reducerPath: "emailRecipientsService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getEmailRecipients: builder.query<any, any>({
      query: (params) => ({
        url: `/partner-recipient/${params?.partnerId}/email-recipients`,
        params,
        method: "GET",
        headers: {
          PageName: "Email Recipients Service",
        },
      }),
    }),
    createEmailRecipient: builder.mutation<any, any>({
      query: (params) => ({
        url: `/partner-recipient/${params?.partner_id}/email-recipients`,
        body: params,
        method: "POST",
        headers: {
          PageName: "Email Recipients Service",
        },
      }),
    }),
    updateEmailRecipient: builder.mutation<any, any>({
      query: (params) => ({
        url: `/partner-recipient/${params?.partner_id}/email-recipients/${params?.id}`,
        body: params,
        method: "PUT",
        headers: {
          PageName: "Email Recipients Service",
        },
      }),
    }),
    deleteEmailRecipient: builder.mutation<any, { id: number; partnerId: number }>({
      query: (params) => ({
        url: `/partner-recipient/${params?.partnerId}/email-recipients/${params?.id}`,
        params,
        method: "DELETE",
        headers: {
          PageName: "Email Recipients Service",
        },
      }),
    }),
  }),
});

export const {
  useGetEmailRecipientsQuery,
  useLazyGetEmailRecipientsQuery,
  useCreateEmailRecipientMutation,
  useUpdateEmailRecipientMutation,
  useDeleteEmailRecipientMutation,
} = emailRecipientsService;
